import { render, staticRenderFns } from "./PopUpCambioPW.vue?vue&type=template&id=47fd5cb4"
import script from "./PopUpCambioPW.vue?vue&type=script&lang=js"
export * from "./PopUpCambioPW.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports